import React from "react";
const Popup = ({ size = "20px"}) => {
    return <svg width={size} height={size} viewBox="0 0 24px 24px" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="#A04D95" d="M16 2H7.979C6.88 2 6 2.88 6 3.98V12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 10H8V4h8zM4 10H2v6c0 1.1.9 2 2 2h6v-2H4z"></path>
</svg>
};
export default Popup;